
import { ArticleItem } from '@/components/article'
import i18n from '@/i18n'
import Vue from 'vue'

export default Vue.extend({
    components: { ArticleItem },
    data() {
        return {
            category: [],
            article: [],
            activeCategoryId: null,
            activeTab: this.$route.params.slug || 'all'
        }
    },
    computed: {
        currentTab: {
            get() {
                return this.$route.params.slug || 'all'
            },
            set(slug) {
                this.$router.push({ params: { slug } })
                this.activeTab = slug
                this.updateActiveCategoryId(slug)
            }
        }
    },
    watch: {
        activeTab(newTab) {
            this.updateActiveCategoryId(newTab)
            this.fetchArticles(newTab)
        }
    },
    async mounted() {
        await this.fetchCategories()
        this.updateActiveCategoryId(this.activeTab)
        await this.fetchArticles(this.activeTab)
    },
    methods: {
        getImageUrl() {
            const imageField = this.landscape ? 'landscape_cover' : 'cover'
            const imageUrl = this.article.length > 0 ? this.article[0].translations[0][imageField] : ''
            return imageUrl ? `${this.$assets}/${imageUrl}` : ''
        },

        async fetchCategories() {
            try {
                const response = await this.$axios.get('/article_category', {
                    params: {
                        fields: '*,translations.*,translations.countries.*,translations.category.*',
                        'filter[type][_eq]': 'experience',
                        'deep[translations][_filter][languages_code][_eq]': i18n.locale,
                    }
                })

                this.category = response.data.data
                if (!this.activeTab && this.category.length > 0) {
                    this.activeTab = 'all'
                    this.activeCategoryId = null
                }
            } catch (error) {
                console.error('Error fetching article category data:', error)
            }
        },

        updateActiveCategoryId(slug) {
            if (slug === 'all') {
                this.activeCategoryId = null
            } else {
                const category = this.category.find(cat => cat.translations[0].slug === slug)
                if (category) {
                    this.activeCategoryId = category.translations[0].article_category_id
                }
            }
        },

        async fetchArticles(slug) {
            //   console.log(`The new slug is: ${slug} and its category ID is: ${this.activeCategoryId}`)
            try {
                const params = {
                    fields: '*,translations.*,translations.countries.*,translations.category.*',
                    'filter[type][_eq]': 'experience',
                    'deep[translations][_filter][languages_code][_eq]': i18n.locale,
                    sort: 'date_created'
                }

                if (slug !== 'all' && this.activeCategoryId) {
                    console.log(`Show relevant images for ${slug}`)
                    params['filter[translations][category][article_category_id][_in]'] = this.activeCategoryId
                }

                const response = await this.$axios.get('/article', { params })
                this.article = response.data.data

                console.log(response.data.data)
            } catch (error) {
                console.error('Error fetching article data:', error)
            }
        }
    }
})
